"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class CustomerFoodPreferences {
    constructor(client) {
        this.getFoodPreferences = async (customerId) => {
            const response = await this.client.post("/graphql", {
                query: `
        query read($id: Int!) {
          coachTrainee(id: $id) {
            breastfeeding
            foodPreferences {
              name
            }
            customFoodPreferences
          }
        }
      `,
                variables: {
                    id: parseInt(customerId),
                },
            });
            if (response.errors) {
                throw new exception_1.BadMethodCallException("Invalid Request: " +
                    response.errors
                        .map(({ message }) => message)
                        .join(", "));
            }
            const coachTrainee = response.data.coachTrainee;
            return {
                allergies: coachTrainee.foodPreferences.filter((foodPreference) => foodPreference.name !== "Borstvoeding"),
                isBreastFeeding: coachTrainee.breastfeeding,
                customAllergies: coachTrainee.customFoodPreferences,
            };
        };
        this.client = client;
    }
}
exports.default = CustomerFoodPreferences;
//# sourceMappingURL=CustomerFoodPreferences.js.map